import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, MapPin, Clock } from 'lucide-react';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-157">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-158" />
  </svg>;
const HERO_IMAGE = 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1920&q=80';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-159">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-160">
        <img src={HERO_IMAGE} alt="El Rey Barba Barbería - Barrio Perdomo" className="w-full h-full object-cover" data-id="element-161" />
        <div className="absolute inset-0 bg-black/65" data-id="element-162"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-164">
          {/* Location Badge */}
          <div className="inline-flex items-center gap-2 bg-gold text-deepblack px-4 py-2 rounded-full font-semibold text-sm mb-6" data-id="element-165">
            <MapPin className="w-4 h-4" data-id="element-166" />
            Barrio Perdomo, Bogotá
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-bone mb-6 leading-tight" data-id="element-167">
            El Arte del Buen Corte
            <br data-id="element-168" />
            en el Sur de Bogotá
          </h1>

          {/* Subheadline */}
          <p className="text-bone text-lg md:text-xl max-w-3xl mx-auto mb-6 leading-relaxed" data-id="element-169">
            Somos LOS ÚNICOS con membresías en cortes para caballeros y niños.
            Modernos, clásicos y con la precisión que tu estilo merece.
          </p>

          {/* Differentiator Badge */}
          <div className="inline-block bg-gold text-deepblack px-6 py-3 rounded-lg font-bold text-base mb-8" data-id="element-170">
            ⭐ Los únicos con membresías en Bogotá Sur
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12" data-id="element-171">
            <a href="https://wa.me/573028281216?text=Hola%20El%20Rey%20Barba%20%F0%9F%91%91%2C%20quiero%20agendar%20una%20cita%20%F0%9F%92%88" target="_blank" rel="noopener noreferrer" className="bg-gold text-deepblack px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-lg hover:shadow-gold-glow" data-id="element-172">
              💬 Agendar mi Cita por WhatsApp
            </a>
            <a href="#membresias" className="border-2 border-gold text-gold px-8 py-4 rounded-full font-bold text-lg hover:bg-gold hover:text-deepblack transition-all" data-id="element-173">
              Ver Membresías →
            </a>
          </div>

          {/* Bottom Row */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 max-w-4xl mx-auto" data-id="element-174">
            {/* Hours Badge */}
            <div className="flex items-center gap-3 bg-black/60 backdrop-blur-sm px-5 py-3 rounded-lg border border-gold/30" data-id="element-175">
              <Clock className="w-5 h-5 text-gold" data-id="element-176" />
              <div className="text-left" data-id="element-177">
                <p className="text-bone font-semibold text-sm" data-id="element-178">
                  🕐 Abiertos Todos los Días
                </p>
                <p className="text-gold text-xs" data-id="element-179">8:30 AM — 9:30 PM</p>
              </div>
            </div>

            {/* Mini Social Icons */}
            <div className="flex items-center gap-4" data-id="element-180">
              <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-181">
                <Instagram className="w-6 h-6" data-id="element-182" />
              </a>
              <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-183">
                <Facebook className="w-6 h-6" data-id="element-184" />
              </a>
              <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-185">
                <WhatsAppIcon data-id="element-186" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}